<a href="#main-content" class="skip-link">Skip to main content</a>
<header class="site-header border-t-4 border-red-600">
  <nav class="header-inner" aria-label="Main navigation">
    <a routerLink="/" class="brand" aria-label="Study Heroes home"
      ><img
        src="/assets/images/logo-v-h.svg"
        width="142"
        height="74"
        alt="Study Heroes"
    /></a>
    <button
      class="menu-toggle"
      type="button"
      (click)="menuOpen = !menuOpen"
      [attr.aria-expanded]="menuOpen"
      aria-controls="primary-links"
    >
      {{ menuOpen ? 'Close' : 'Menu' }} <span aria-hidden="true">☰</span>
    </button>
    <div
      id="primary-links"
      class="primary-links"
      [class.is-open]="menuOpen"
      (click)="closeMenuOnNavigation($event)"
      (keydown.escape)="menuOpen = false"
    >
      <div
        class="resource-menu"
        [class.is-open]="resourceMenuOpen"
        (mouseenter)="resourceMenuOpen = true"
        (mouseleave)="resourceMenuOpen = false"
        (focusin)="resourceMenuOpen = true"
        (focusout)="closeResourceMenuOnBlur($event)"
      >
        <a
          routerLink="/search"
          routerLinkActive="active"
          class="resource-trigger"
          >Resources
          <svg
            class="chevron"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </a>
        <div class="resource-dropdown" aria-label="Resource types">
          <button type="button" (click)="showAllMedia()">All Media</button>
          @for (type of resourceTypes$ | async; track type.id) {
            <button type="button" (click)="filterByResourceType(type.name)">
              {{ type.name }}
            </button>
          }
        </div>
      </div>
      <a routerLink="/shelves" routerLinkActive="active">Shelves</a>
      <a routerLink="/get-involved" routerLinkActive="active">Get involved</a>
      <a routerLink="/about" routerLinkActive="active">About</a>
      <details
        #adminMenu
        class="account-menu"
        *ngIf="['SuperAdmin', 'Admin'] | hasRole | async"
        (mouseleave)="closeDropdownMenu(adminMenu)"
        (focusout)="closeDropdownMenuOnBlur($event, adminMenu)"
        (keydown.escape)="closeDropdownMenu(adminMenu)"
      >
        <summary>Admin</summary>
        <div class="dropdown-panel" (click)="closeDropdownMenu(adminMenu)">
          <a routerLink="/categories">Categories</a
          ><a routerLink="/users">Users</a><a routerLink="/books">Books</a
          ><a routerLink="/flags">Flags</a><a routerLink="/formats">Formats</a>
        </div>
      </details>
    </div>
    <div class="header-actions">
      <details
        #languageMenu
        class="language-menu"
        (mouseleave)="closeLanguageMenu(languageMenu)"
      >
        <summary aria-label="Choose language">
          <img
            class="language-flag"
            [src]="'/assets/flags/' + selectedLanguageCode + '.svg'"
            alt=""
            aria-hidden="true"
          />
          <span>{{ selectedLanguage }}</span>
          <svg
            class="chevron"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </summary>
        <div class="dropdown-panel language-dropdown">
          @for (language of languages; track language.code) {
            <button
              type="button"
              [class.is-selected]="language.name === selectedLanguage"
              (click)="selectLanguage(language.code, languageMenu)"
            >
              <img
                class="language-flag"
                [src]="'/assets/flags/' + language.code + '.svg'"
                alt=""
                aria-hidden="true"
              />
              {{ language.name }}
            </button>
          }
        </div>
      </details>
      <!-- <button type="button" class="app-link" (click)="openAppModal()">
        <svg
          width="19"
          height="19"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          aria-hidden="true"
        >
          <rect x="6" y="2.5" width="12" height="19" rx="2" />
          <path d="M10 18.5h4" />
        </svg>
        Download App
      </button> -->
      <a
        routerLink="/search"
        [queryParams]="{ autoFocus: true }"
        class="search-link"
        aria-label="Search resources"
        ><svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          aria-hidden="true"
        >
          <circle cx="10.5" cy="10.5" r="6.5" />
          <path d="m16 16 5 5" /></svg
      ></a>
      @if (auth.authCredentials$ | async) {
        <details
          #profileMenu
          class="account-menu"
          (mouseleave)="closeDropdownMenu(profileMenu)"
          (focusout)="closeDropdownMenuOnBlur($event, profileMenu)"
          (keydown.escape)="closeDropdownMenu(profileMenu)"
        >
          <summary aria-label="Your account">
            <img
              [src]="'assets/images/avatars/' + (avatarImage$ | async)"
              width="40"
              height="40"
              alt="Your account"
            />
          </summary>
          <div class="dropdown-panel" (click)="closeDropdownMenu(profileMenu)">
            <a routerLink="/profile">Profile</a
            ><button type="button" (click)="auth.signOut()">Sign out</button>
          </div>
        </details>
      } @else {
        <a routerLink="/login" class="sign-in"
          >Sign in <span aria-hidden="true">→</span></a
        >
      }
    </div>
  </nav>
</header>
